<style>
    * {
        all: revert;
    }
    .privacyBlock {
        margin-top: 15px;
    }
    .privacyBlock,
    .publicationBlock {
        display: none;
    }
</style>

<script lang="ts">
    import { _ } from 'svelte-i18n';

    import SelectInput, {
        OptionType
    } from '@eqs/cms-svelte-irtools/form/components/SelectInput.svelte';
    import { TextInputSvelte } from '@eqs/cms-svelte-irtools/form/components';
    import CheckBoxInput from '@eqs/cms-svelte-irtools/form/components/CheckboxInput.svelte';
    import {
        combineValidates,
        email as emailValidator,
        required
    } from '@eqs/cms-svelte-irtools/form';
    import type { PersonInfoType } from '../utils/types';
    import type { ValidateFunction } from '@eqs/cms-svelte-irtools/form';

    export let data: PersonInfoType;
    export let distributionList: string[] = [];
    export let supportedDist: string[] = [];
    let inputError: { [key: string]: undefined | string } = {};

    const genderOptions: OptionType[] = [
        { name: $_('dropdown_options.salutation.male'), value: 'male' },
        { name: $_('dropdown_options.salutation.female'), value: 'female' },
        { name: $_('dropdown_options.salutation.neutral'), value: 'neutral' }
    ];
    const publicationOptions: OptionType[] = [
        {
            name: $_('dropdown_options.publication.adhoc_news'),
            value: 'Adhoc_News'
        },
        {
            name: $_('dropdown_options.publication.corporate_news'),
            value: 'Corporate_News'
        }
    ];

    const affiliationOptions: OptionType[] = [
        {
            name: $_('dropdown_options.affiliation.private_investor'),
            value: 'Private_Investor'
        },
        {
            name: $_('dropdown_options.affiliation.institutional_investor'),
            value: 'Institutional_Investor'
        },
        { name: $_('dropdown_options.affiliation.analyst'), value: 'Analyst' },
        {
            name: $_('dropdown_options.affiliation.journalist'),
            value: 'Journalist'
        },
        { name: $_('dropdown_options.affiliation.other'), value: 'Other' }
    ];
    const affiliationToDLMap: { [key: string]: string } = {
        Adhoc_News: 'ad-hoc-news',
        Corporate_News: 'corporate-news'
    };
    const categoryToDLMap: { [key: string]: string } = {
        Adhoc_News: 'ad-hoc-news',
        Corporate_News: 'corporate-news',
        Private_Investor: 'private-investor',
        Institutional_Investor: 'institutional-investor',
        Analyst: 'analyst',
        Journalist: 'journalist',
        Other: 'other'
    };

    // supportedDist = Object.values(affiliationToDLMap);
    supportedDist = Object.values(categoryToDLMap);

    $: {
        if (data.publication) {
            distributionList = [affiliationToDLMap[data.publication]];
        }
    }

    const validates: { [key: string]: ValidateFunction } = {};
    export const validate: ValidateFunction = async () => {
        await combineValidates(...Object.values(validates))();
    };

    setTimeout(function () {
        function insertAfter(referenceNode, newNode) {
            referenceNode.parentNode.insertBefore(
                newNode,
                referenceNode.nextSibling
            );
        }
        var el = document.querySelector('.privacyBlock');
        var divEl = document.querySelector('.publicationBlock');
        insertAfter(divEl, el);
        divEl.style.display = 'block';
        el.style.display = 'block';
    }, 300);
</script>

<div>
    <div class="personal-details">
        <div class="eqs-cms__subscribeForm--group">
            <SelectInput
                bind:value="{data.gender}"
                label="{$_('contact_form.labels.salutation')}*"
                placeholder="{$_('contact_form.labels.select_gender')}"
                options="{genderOptions}"
                validators="{[
                    required(
                        $_('generic.validation.required', {
                            values: { field: 'gender' }
                        })
                    )
                ]}"
                bind:validate="{validates.gender}"
            />
        </div>
        <div class="eqs-cms__subscribeForm--group">
            <TextInputSvelte
                bind:value="{data.jobTitle}"
                label="{$_('contact_form.labels.job_title')}"
            />
        </div>
        <div class="eqs-cms__subscribeForm--group">
            <TextInputSvelte
                bind:value="{data.firstName}"
                label="{$_('contact_form.labels.first_name')} *"
                validators="{[
                    required(
                        $_('generic.validation.required', {
                            values: { field: 'firstName' }
                        })
                    )
                ]}"
                bind:validate="{validates.firstName}"
            />
        </div>
        <div class="eqs-cms__subscribeForm--group">
            <TextInputSvelte
                bind:value="{data.lastName}"
                label="{$_('contact_form.labels.last_name')} *"
                validators="{[
                    required(
                        $_('generic.validation.required', {
                            values: { field: 'lastName' }
                        })
                    )
                ]}"
                bind:validate="{validates.lastName}"
            />
        </div>
        <div class="eqs-cms__subscribeForm--group">
            <TextInputSvelte
                bind:value="{data.email}"
                type="email"
                label="{$_('contact_form.labels.email')} *"
                validators="{[
                    required(
                        $_('generic.validation.required', {
                            values: { field: 'email' }
                        })
                    ),
                    emailValidator(
                        $_('generic.validation.email', {
                            values: { field: 'email' }
                        })
                    )
                ]}"
                bind:validate="{validates.email}"
                bind:error="{inputError.email}"
                cssClass="{inputError.email ? 'error' : ''}"
            />
        </div>
        <div class="eqs-cms__subscribeForm--group">
            <TextInputSvelte
                bind:value="{data.company}"
                label="{$_('contact_form.labels.company')}"
            />
        </div>
    </div>

    <div class="distribution-block">
        <div class="eqs-cms__subscribeForm--group">
            {$_('contact_form.labels.distribution_text')}
            <SelectInput
                bind:value="{data.affiliation}"
                label=" "
                placeholder="{$_('contact_form.labels.affiliation')}"
                options="{affiliationOptions}"
                validators="{[
                    required(
                        $_('generic.validation.required', {
                            values: { field: 'affiliation' }
                        })
                    )
                ]}"
                bind:validate="{validates.affiliation}"
            />
        </div>
    </div>

    <div class="eqs-cms__subscribeForm--group privacyBlock">
        <CheckBoxInput
            containerCssClass="checkbox checkboxPrivacy"
            type="checkbox"
            label="{$_('contact_form.labels.privacy_text')}*"
            validators="{[
                required(
                    $_('generic.validation.required', {
                        values: { field: 'privacy' }
                    })
                )
            ]}"
            bind:validate="{validates.privacy}"
        />
    </div>
</div>
